/* ============================================================
   PRODUCT MERCH ANIMATION - FIXED (merch template only)
   Changes vs original:
   1. REMOVED `pin: true` from the .kg-section-info trigger.
      Pinning is not supported with containerAnimation in GSAP;
      it pulled the DETAILS panel out of the horizontal flex row
      and overlapped it on top of the hero panel.
   2. Container width is now recomputed on every ScrollTrigger
      refresh (resize / image load) instead of measured once.
   3. ScrollTrigger.refresh() runs after images + fonts + full
      page load, so measurements never go stale.
   4. Null guards so one missing element can't crash the script.
   ============================================================ */

if (document.querySelector(".intro") && typeof SplitType !== "undefined") {
  const intro = new SplitType(".intro");
  gsap.to(".word", {
    y: 0,
    opacity: 1,
    delay: 0.6,
    duration: 0.6,
    stagger: { each: 0.06 },
  });
}

gsap.registerPlugin(ScrollTrigger);

const extraLongContainer = document.querySelector(".extra-long-container");
const kgPenalGroup = extraLongContainer
  ? extraLongContainer.querySelector(".kg-penal-group")
  : null;
const childSections = kgPenalGroup
  ? kgPenalGroup.querySelectorAll("section")
  : [];
const panelsNavigation = document.querySelector(".nav-panel");

var dynamis1x = 150;
var dynamis2x = 30;
var isVideoPlaying = true;
var repeat_s2_animation = 1;

/* ---------- FIX 2: width is a function, re-measured on refresh ---------- */
function computeTotalWidth() {
  let w = 0;
  childSections.forEach((section) => {
    w += section.offsetWidth;
  });
  return w;
}

let totalWidth = computeTotalWidth();
if (extraLongContainer) {
  extraLongContainer.style.width = totalWidth + "px";
}

/* Vertical distance the gallery column must travel: how much taller the
   grid is than its 100vh clip window. 0 when it already fits or off desktop. */
function computeGalleryScroll() {
  if (!window.matchMedia("(min-width: 990px)").matches) return 0;
  const win = document.querySelector(".gallery-desktop");
  const grid = document.querySelector(".kgg-grid");
  if (!win || !grid) return 0;
  return Math.max(0, grid.scrollHeight - win.clientHeight);
}

let galleryScroll = computeGalleryScroll();

// Re-measure panels every time ScrollTrigger recalculates
ScrollTrigger.addEventListener("refreshInit", function () {
  totalWidth = computeTotalWidth();
  galleryScroll = computeGalleryScroll();
  if (extraLongContainer) {
    extraLongContainer.style.width = totalWidth + "px";
  }
});

/* ---------- Horizontal scroll ---------- */
let scrollTween = null;

if (extraLongContainer && childSections.length) {
  scrollTween = gsap.timeline({
    scrollTrigger: {
      trigger: ".extra-long-container",
      start: "top top",
      // Pin spans BOTH phases: horizontal pan + gallery column scroll.
      end: () => "+=" + (totalWidth + galleryScroll) + "px",
      scrub: 1,
      pin: true,
      invalidateOnRefresh: true,
      anticipatePin: 1,
      onEnter: () => {
        s1(10);
      },
      onUpdate: (self) => {
        // self.progress covers horizontal + gallery. Rescale to the
        // horizontal fraction so the existing phase-1 effects still key
        // off "how far through the horizontal pan are we".
        const hFrac =
          totalWidth + galleryScroll > 0
            ? totalWidth / (totalWidth + galleryScroll)
            : 1;
        const hProgress = hFrac > 0 ? Math.min(self.progress / hFrac, 1) : 1;
        const progress = parseFloat(hProgress.toFixed(2));

        if (progress <= 0.09) {
          if (self.direction == -1) {
            if (dynamis1x != 10) {
              dynamis1x = dynamis1x - 10;
            }
            s1(dynamis1x);
            repeat_s2_animation = 1;
          }
        } else if (progress >= 0.1 && progress <= 0.4) {
          if (dynamis2x != 150) {
            dynamis2x = dynamis2x + 10;
          }
          s2(dynamis2x);

          if (isVideoPlaying) {
            isVideoPlaying = false;
          }
          if (self.direction == -1) {
            isVideoPlaying = true;
          }
        }
      },
    },
  });

  // Segment 1: horizontal pan. Duration weighted by totalWidth so it owns
  // the first `totalWidth` px of the pinned scroll.
  scrollTween.to(
    extraLongContainer,
    {
      duration: totalWidth || 1,
      xPercent: -100,
      x: () => window.innerWidth,
      ease: "none",
    },
    0
  );

  // Segment 2: gallery column scrolls up. Duration weighted by galleryScroll
  // so it owns the remaining pinned scroll. y is function-based so it
  // recomputes on refresh via invalidateOnRefresh.
  scrollTween.to(
    ".kgg-grid",
    {
      duration: galleryScroll || 0.0001,
      y: () => -computeGalleryScroll(),
      ease: "none",
    },
    ">"
  );
}

function s2(x) {
  const items = document.querySelectorAll(".text-number .kg-text h1");
  const itemsProgressBar = document.querySelectorAll(".progress .progress-done");
  var scroll_2 = gsap.timeline();

  if (repeat_s2_animation) {
    scroll_2
      .from(itemsProgressBar, {
        width: "0%",
        ease: "power2.out",
      })
      .from(items, {
        textContent: 0.0,
        ease: "power2.in",
        snap: { textContent: 0.1 },
        stagger: {
          onUpdate: function () {
            this.targets()[0].innerHTML = this.targets()[0].textContent;
          },
          onComplete: function () {
            const finalValue = this.targets()[0].textContent;
            if (finalValue.length === 1) {
              this.targets()[0].innerHTML = finalValue;
            }
          },
        },
      });
    repeat_s2_animation = 0;
  }
}

function s1(x) {
  var loadtextAnimation = new TimelineMax();
  loadtextAnimation
    .to(".kg-appear-delay-1", 1, { y: 0, opacity: 1, delay: 0.2 }, 0)
    .to(".kg-appear-delay-2", 1, { y: 0, opacity: 1, delay: 0.3 }, 0)
    .to(".kg-appear-delay-3", 1, { y: 0, opacity: 1, delay: 0.4 }, 0)
    .to(".kg-appear-delay-4", 1, { y: 0, opacity: 1, delay: 0.5 }, 0)
    .to(".kg-appear-delay-5", 1, { y: 0, opacity: 1, delay: 0.6 }, 0)
    .to(".kg-appear-delay-6", 1, { y: 0, opacity: 1, delay: 0.7 }, 0)
    .to(".kg-appear-delay-7", 1, { y: 0, opacity: 1, delay: 0.8 }, 0)
    .to(".kg-appear-delay-8", 1, { y: 0, opacity: 1, delay: 0.9 }, 0)
    .to(".kg-appear-delay-9", 1, { y: 0, opacity: 1, delay: 0.1 }, 0)
    .to(".kg-appear-delay-10", 1, { y: 0, opacity: 1, delay: 0.11 }, 0)
    .to(".kg-appear-delay-11", 1, { y: 0, opacity: 1, delay: 0.12 }, 0)
    .to(".kg-appear-delay-12", 1, { y: 0, opacity: 1, delay: 0.13 }, 0)
    .to(".kg-appear-delay-13", 1, { y: 0, opacity: 1, delay: 0.14 }, 0)
    .to(".kg-appear-delay-14", 1, { y: 0, opacity: 1, delay: 0.15 }, 0)
    .to(".kg-appear-delay-15", 1, { y: 0, opacity: 1, delay: 0.16 }, 0);
}

ScrollTrigger.create({
  trigger: "#panel-3",
  start: "top 100%",
  end: "top 50%",
});

/* ---------- FIX 1: text reveal WITHOUT pin ----------
   pin:true is invalid with containerAnimation - it yanked
   .kg-section-info out of the flex row and overlapped it
   on top of the hero panel. The reveal works fine without it:
   the panel is already "pinned" by the main horizontal tween. */
if (scrollTween && document.querySelector(".kg-section-info")) {
  var text_animation_scroll_2 = gsap.timeline({
    scrollTrigger: {
      trigger: ".kg-section-info",
      containerAnimation: scrollTween,
      start: "left 100%",
      end: "left 20%",
      scrub: 2,
    },
  });
  text_animation_scroll_2
    .to(".kg-anim-delay-1", { opacity: "1", x: "0%", delay: 0.2 }, "b")
    .to(".kg-anim-delay-2", { opacity: "1", x: "0%", delay: 0.3 }, "b")
    .to(".kg-anim-delay-3", { opacity: "1", x: "0%", delay: 0.4 }, "b")
    .to(".kg-anim-delay-4", { opacity: "1", x: "0%", delay: 0.5 }, "b")
    .to(".kg-anim-delay-5", { opacity: "1", x: "0%", delay: 0.6 }, "b");
}

const progresses = document.querySelectorAll(".progress-done");
progresses.forEach((progress) => {
  progress.style.opacity = 1;
  progress.style.width = progress.getAttribute("data-done") + "%";
});

if (panelsNavigation && scrollTween) {
  var scroll_2_next = gsap.timeline({
    scrollTrigger: {
      trigger: panelsNavigation,
      containerAnimation: scrollTween,
      start: "center 85%",
      end: "center 60%",
      scrub: 2,
      markers: false,
    },
  });
  scroll_2_next.to(panelsNavigation, {
    scale: 0,
  });
}

/* ---------- FIX 3: refresh after late-loading content ---------- */
(function () {
  var refreshTimer = null;

  function queueRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      ScrollTrigger.refresh();
    }, 150);
  }

  // Images inside the panels (product photos, gallery grid, info icons)
  document
    .querySelectorAll(".kg-product-panel img, .kgg-grid img")
    .forEach(function (img) {
      if (img.complete) return;
      img.addEventListener("load", queueRefresh, { once: true });
      img.addEventListener("error", queueRefresh, { once: true });
    });

  window.addEventListener("load", queueRefresh);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(queueRefresh);
  }
})();
